export const listFormat = new Intl.ListFormat("en", {
  style: "long",
  type: "conjunction",
});

export const listFormatDisjunction = new Intl.ListFormat("en", {
  style: "long",
  type: "disjunction",
});
